import { render, staticRenderFns } from "./Wap_WXCW81_View.vue?vue&type=template&id=c15a1028&scoped=true&"
import script from "./Wap_WXCW81_View.vue?vue&type=script&lang=js&"
export * from "./Wap_WXCW81_View.vue?vue&type=script&lang=js&"
import style0 from "./Wap_WXCW81_View.vue?vue&type=style&index=0&id=c15a1028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a1028",
  null
  
)

export default component.exports